import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { GenerateStudentAccessModalComponent } from '../../../students/generate-student-access-modal/generate-student-access-modal.component';
import { FeatureHelperService } from '../../../_helpers/feature-helper/feature-helper.service';
import { ThemeService } from '../../../_helpers/theming-engine/theme.service';
import { TutorReportsHelperService } from '../../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { Baseline, PlacementStudentV2 } from '../../../_models';
import { GenerateStudentAccessModalData } from '../../../_models/grant-student-access/generate-student-access-modal-data.model';
import { StudentOutcomesComponent, TutorReportsBaselineComponent } from '../..';
import { PlacementService } from '../../../_services';
import { ErrorModalHelperService } from '../../../_helpers/error-modal-helper/error-modal-helper.service';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanelHeader } from '@angular/material/expansion';

@Component({
    selector: 'group-student-info',
    templateUrl: './group-student-info.component.html',
    styleUrls: ['./group-student-info.component.css'],
    standalone: false
})
export class GroupStudentInfoComponent implements OnInit {
  @Input() student: PlacementStudentV2;

  @Output() backToStudents: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(TutorReportsBaselineComponent, { static: false }) baselineComp;
  @ViewChild(StudentOutcomesComponent, { static: false }) outcomeComp;
  @ViewChild('refBaseline', { static: false }) refBaseline;

  public statusDescription: string = "";
  public generateStudentAccessPermission: boolean;

  public isBaselineOpen: boolean = false;

  public ilpPanelOpenState: boolean = false;
  public baselineStatusDescription: string = 'New';
  
  constructor(
    private tutorReportsHelperService: TutorReportsHelperService,
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    public dialog: MatDialog,
    private placementService: PlacementService,
    private errorModalHelper: ErrorModalHelperService
    ) { }

  ngOnInit() {
    let featureList = new Array<string>();
      featureList.push("GenerateStudentAccess");

      let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

      this.generateStudentAccessPermission = currentUserFeatures.filter(f => f.feature === "GenerateStudentAccess")[0].enabled;
  }

  public renderStudentBaseline() {
    this.tutorReportsHelperService.setIsStudentGroup(this.student.studentId);
    setTimeout(() => {
      if (this.refBaseline) {
        this.refBaseline.renderComponent();
      }
    }, 10);
  }
  
  public renderStudentProgressReport(refOutcomes: StudentOutcomesComponent) {
    this.tutorReportsHelperService.setIsStudentGroup(this.student.studentId);
    setTimeout(() => {
      refOutcomes.getData();
    }, 10);
  }

  public onBaselineClosed(baselineHeader: MatExpansionPanelHeader): void {
    baselineHeader._toggle();
  }

  public grantStudentAccess(): void {
    let data = new GenerateStudentAccessModalData();
    data.studentId = this.student.studentId;
    data.studentName = this.student.studentFirstName + " " + this.student.studentLastName;
    data.showSignUpEmailButton = this.student.studentHasEmail;
    data.showWebsiteLinkButton = true;

    const dialogRef = this.dialog.open(GenerateStudentAccessModalComponent, {
      data: data,
      panelClass: 'my-dialog'
    });
  }

  public backToStudentList(): void {
    this.backToStudents.emit();
  }

  public baselineStatusUpdated(status: string): void {
    this.baselineStatusDescription = status;
  }

}
